/* After a product-page accordion row (Dimensions / Specifications / Shipping &
   Returns) expands, it scrolls itself into view, behaving like an anchor jump:
   the expanded row travels to "just below the sticky header, plus a little
   margin".

   Why it is needed: these rows sit below the description text. By the time the
   page is scrolled far enough to tap one, the row itself is already near the
   bottom of the viewport, so its content opens entirely below the fold —
   nothing on screen changes and the customer assumes the tap did nothing.

   It only scrolls when the expanded content fails to come fully into view.
   If it is already visible, nothing moves, avoiding pointless jumps. */
(() => {
  const GAP = 16; // Breathing room between the header and the accordion row; purely visual margin, not part of the type/spacing system

  const stickyOffset = () => {
    const header = document.querySelector('.section-header');
    if (!header) return 0;
    const position = getComputedStyle(header).position;
    // A non-sticky header scrolls away and stops occupying the viewport, so it should not count toward the offset
    if (position !== 'sticky' && position !== 'fixed') return 0;
    return header.getBoundingClientRect().height;
  };

  document.addEventListener(
    'toggle',
    (event) => {
      const details = event.target;
      if (!(details instanceof HTMLDetailsElement) || !details.open) return;
      if (!details.closest('.product__accordion')) return;
      // The quick-add modal contains the same accordion rows. Scrolling the main document there would only scroll the page behind the modal.
      if (details.closest('quick-add-modal, .quick-add-modal, .drawer, dialog')) return;

      requestAnimationFrame(() => {
        const rect = details.getBoundingClientRect();
        const top = stickyOffset() + GAP;
        if (rect.top >= top && rect.bottom <= window.innerHeight) return;

        window.scrollTo({
          top: window.scrollY + rect.top - top,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        });
      });
    },
    true // toggle does not bubble, so it can only be caught in the capture phase
  );
})();
